// extracted by mini-css-extract-plugin
export default {"main":"QuestionComponent_main__U2edm","question":"QuestionComponent_question__VrOtI","answer":"QuestionComponent_answer__LM2ia"};